import * as Sentry from "@sentry/angular";
import {enableProdMode} from '@angular/core';
import {AppModule} from './app/app.module';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
defineCustomElements(window);

import {environment} from './environments/environment';
import { CURRENT_VERSION } from "./app/app.config";
import { platformBrowser } from "@angular/platform-browser";


if (environment.production) {
  enableProdMode();
}

Sentry.init({
    dsn: "https://02662ba022f1ec3ab38c62ffc3451b99@o4509673714352128.ingest.us.sentry.io/4509673714483200",
    tunnel: `${environment.apiUrl}/sentry/tunnel`,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    release: CURRENT_VERSION,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
});

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
